// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PlpViewButtonCondensedRow: React.FC<{
    size?: number;
}> = ({ size = 16 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
        <path
            fill="currentColor"
            transform="translate(0 -2.86102e-06)"
            d="M1.5 3.5L1.5 2.5L2.5 2.5L2.5 3.5L1.5 3.5ZM0.5 2.25L0.5 3.75C0.5 4.1656246 0.8343749 4.5 1.25 4.5L2.75 4.5C3.1656251 4.5 3.5 4.1656246 3.5 3.75L3.5 2.25C3.5 1.8343754 3.1656251 1.5 2.75 1.5L1.25 1.5C0.8343749 1.5 0.5 1.8343754 0.5 2.25ZM5.5 2.5C5.2249999 2.5 5 2.7250004 5 3C5 3.2749996 5.2249999 3.5 5.5 3.5L15.5 3.5C15.775 3.5 16 3.2749996 16 3C16 2.7250004 15.775 2.5 15.5 2.5L5.5 2.5ZM5.5 7.5C5.2249999 7.5 5 7.7249999 5 8C5 8.2749996 5.2249999 8.5 5.5 8.5L15.5 8.5C15.775 8.5 16 8.2749996 16 8C16 7.7250004 15.775 7.5 15.5 7.5L5.5 7.5ZM5.5 12.5C5.2249999 12.5 5 12.725 5 13C5 13.275 5.2249999 13.5 5.5 13.5L15.5 13.5C15.775 13.5 16 13.275 16 13C16 12.725 15.775 12.5 15.5 12.5L5.5 12.5ZM1.5 7.5L2.5 7.5L2.5 8.5L1.5 8.5L1.5 7.5ZM1.25 6.5C0.8343749 6.5 0.5 6.8343749 0.5 7.25L0.5 8.75C0.5 9.1656246 0.8343749 9.5 1.25 9.5L2.75 9.5C3.1656251 9.5 3.5 9.1656246 3.5 8.75L3.5 7.25C3.5 6.8343749 3.1656251 6.5 2.75 6.5L1.25 6.5ZM1.5 13.5L1.5 12.5L2.5 12.5L2.5 13.5L1.5 13.5ZM0.5 12.25L0.5 13.75C0.5 14.165625 0.8343749 14.5 1.25 14.5L2.75 14.5C3.1656251 14.5 3.5 14.165625 3.5 13.75L3.5 12.25C3.5 11.834375 3.1656251 11.5 2.75 11.5L1.25 11.5C0.8343749 11.5 0.5 11.834375 0.5 12.25Z"
        />
    </svg>
);

export default React.memo(PlpViewButtonCondensedRow);
